import { LinkInBioGenerator } from '@/components/dashboard/LinkInBioGenerator';

export default function HostLinkInBio() {
  return <LinkInBioGenerator />;
}
